import { ItemPickerModel } from 'src/app/shared/components/item-picker/models/itemPickerModel';

export enum CredentialScenarioReportFields {
  id = 'id',
  personId = 'personId',
  personCredentialId = 'personCredentialId',
  imageId = 'imageId',
  email = 'email',
  firstName = 'firstName',
  middleName = 'middleName',
  lastName = 'lastName',
  fullName = 'fullName',
  externalSystemId = 'externalSystemId',
  scenarioDefinitionId = 'scenarioDefinitionId',
  scenarioName = 'scenarioName',
  credentialApplicationNumber = 'credentialApplicationNumber',
  scenarioCompletion = 'scenarioCompletion',
  scenarioType = 'scenarioType',
  credentialApplicationStartDate = 'credentialApplicationStartDate',
  credentialApplicationEndDate = 'credentialApplicationEndDate',
  personScenarioUpdatedBy = 'personScenarioUpdatedBy',
  personScenarioUpdatedOn = 'personScenarioUpdatedOn',
  personScenarioCreatedBy = 'personScenarioCreatedBy',
  personScenarioCreatedOn = 'personScenarioCreatedOn',
  credentialDefinitionId = 'credentialDefinitionId',
  credentialName = 'credentialName',
  credentialApplicationType = 'credentialApplicationType',
  requirements = 'requirements',
  status = 'status',
  tags = 'tags',
  teamName = 'name',
  teamPublicName = 'publicName',
  workspaceName = 'workspaceName'
}

export const PersonScenarioReportSystemColumns: ItemPickerModel[] = [
  new ItemPickerModel(CredentialScenarioReportFields.firstName, '', 'First Name'),
  new ItemPickerModel(CredentialScenarioReportFields.lastName, '', 'Last Name'),
  new ItemPickerModel(CredentialScenarioReportFields.email, '', 'Email'),
  new ItemPickerModel(
    CredentialScenarioReportFields.credentialApplicationNumber,
    '',
    'Application Number'
  ),
  new ItemPickerModel(
    CredentialScenarioReportFields.credentialApplicationStartDate,
    '',
    'Application Start'
  ),
  new ItemPickerModel(
    CredentialScenarioReportFields.credentialApplicationEndDate,
    '',
    'Application End'
  ),
  new ItemPickerModel(CredentialScenarioReportFields.status, '', 'Status'),
  new ItemPickerModel(
    CredentialScenarioReportFields.credentialApplicationType,
    '',
    'Application Type'
  ),
  new ItemPickerModel(CredentialScenarioReportFields.tags, '', 'Tags')
];

export const TeamScenarioReportSystemColumns: ItemPickerModel[] = [
  new ItemPickerModel(CredentialScenarioReportFields.teamName, '', 'Team Name'),
  new ItemPickerModel(CredentialScenarioReportFields.teamPublicName, '', 'Team Public Name'),
  new ItemPickerModel(CredentialScenarioReportFields.workspaceName, '', 'Workspace Name'),
  new ItemPickerModel(
    CredentialScenarioReportFields.credentialApplicationNumber,
    '',
    'Application Number'
  ),
  new ItemPickerModel(
    CredentialScenarioReportFields.credentialApplicationStartDate,
    '',
    'Application Start'
  ),
  new ItemPickerModel(
    CredentialScenarioReportFields.credentialApplicationEndDate,
    '',
    'Application End'
  ),
  new ItemPickerModel(CredentialScenarioReportFields.status, '', 'Status'),
  new ItemPickerModel(
    CredentialScenarioReportFields.credentialApplicationType,
    '',
    'Application Type'
  ),
  new ItemPickerModel(CredentialScenarioReportFields.tags, '', 'Tags')
];

export enum CredentialScenarioTagFilterFields {
  id = 'id',
  text = 'text'
}
